(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8872],{

/***/ 16110:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ withAuth; }
/* harmony export */ });
/* harmony import */ var _app_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(50029);
/* harmony import */ var _app_web_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87794);
/* harmony import */ var _app_web_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_app_web_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _fh_components_fh_js_api_core_store_slices_userSlice__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(46789);
/* harmony import */ var _store__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(12325);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);





function withAuth(f) {
  return /*#__PURE__*/function () {
    var _ref = (0,_app_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)( /*#__PURE__*/_app_web_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(args) {
      var res, reduxStore, pathname, asPath, loggedIn;
      return _app_web_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              res = args.res, reduxStore = args.reduxStore, pathname = args.pathname, asPath = args.asPath;
              loggedIn = (0,_store__WEBPACK_IMPORTED_MODULE_2__/* .isLoggedInSelector */ .dd)(reduxStore.getState());

              if (!loggedIn) {
                _context.next = 4;
                break;
              }

              return _context.abrupt("return", f(args));

            case 4:
              if (!res) {
                _context.next = 10;
                break;
              }

              res.cookie('fh_redirect_url', pathname, {
                path: '/',
                expires: new Date(Date.now() + 3600 * 1000)
              });
              res.writeHead(302, {
                Location: '/login'
              });
              res.end();
              _context.next = 13;
              break;

            case 10:
              _context.next = 12;
              return reduxStore.dispatch((0,_fh_components_fh_js_api_core_store_slices_userSlice__WEBPACK_IMPORTED_MODULE_1__/* .changeRedirectUrl */ .ZA)({
                href: pathname,
                asPath: asPath
              }));

            case 12:
              next_router__WEBPACK_IMPORTED_MODULE_3___default().push('/login');

            case 13:
              return _context.abrupt("return", {});

            case 14:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
}

/***/ }),

/***/ 53927:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ withSession; }
/* harmony export */ });
/* unused harmony export withSessionRefreshed */
/* harmony import */ var _app_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(50029);
/* harmony import */ var _app_web_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87794);
/* harmony import */ var _app_web_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_app_web_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _fh_components_fh_js_api_core_store_slices_sessionSlice__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(28770);



function withSession(f) {
  return /*#__PURE__*/function () {
    var _ref = (0,_app_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)( /*#__PURE__*/_app_web_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(args) {
      var reduxStore;
      return _app_web_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              reduxStore = args.reduxStore;
              _context.next = 3;
              return reduxStore.dispatch((0,_fh_components_fh_js_api_core_store_slices_sessionSlice__WEBPACK_IMPORTED_MODULE_1__/* .createSession */ .ed)());

            case 3:
              return _context.abrupt("return", f(args));

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
}
function withSessionRefreshed(f) {
  return /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(args) {
      var reduxStore;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              reduxStore = args.reduxStore;
              _context2.next = 3;
              return reduxStore.dispatch(createSession(true));

            case 3:
              return _context2.abrupt("return", f(args));

            case 4:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function (_x2) {
      return _ref2.apply(this, arguments);
    };
  }();
}

/***/ }),

/***/ 746:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ NextUserProfilePage; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _shopify_react_idle__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(17548);
/* harmony import */ var _lib_withSession__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(53927);
/* harmony import */ var _lib_withAuth__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(16110);
/* harmony import */ var _seo_Ecommerce__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(31893);
/* harmony import */ var _components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(70517);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(85893);








var UserPage = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function () {
  return __webpack_require__.e(/* import() */ 6497).then(__webpack_require__.bind(__webpack_require__, 56497));
}, {
  loading: function loading() {
    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_components__WEBPACK_IMPORTED_MODULE_5__/* .Loader */ .aN, {});
  },
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(56497)];
    }
  }
});
function NextUserProfilePage() {
  var setPageType = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function () {
    _seo_Ecommerce__WEBPACK_IMPORTED_MODULE_4__/* ["default"].setPageType */ .ZP.setPageType(_seo_Ecommerce__WEBPACK_IMPORTED_MODULE_4__/* ["default"].PAGE_TYPES.PROFILE */ .ZP.PAGE_TYPES.PROFILE);
  }, []);
  (0,_shopify_react_idle__WEBPACK_IMPORTED_MODULE_7__/* .useIdleCallback */ .Y)(setPageType);
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(UserPage, {
    type: "user-profile"
  });
}
NextUserProfilePage.getInitialProps = (0,_lib_withSession__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_lib_withAuth__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function () {
  return {};
}));

/***/ }),

/***/ 72002:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/user/profile",
      function () {
        return __webpack_require__(746);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 17548:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Y": function() { return /* binding */ useIdleCallback; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./node_modules/@shopify/react-idle/build/esm/types.mjs
let UnsupportedBehavior;

(function (UnsupportedBehavior) {
  UnsupportedBehavior[UnsupportedBehavior["Immediate"] = 0] = "Immediate";
  UnsupportedBehavior[UnsupportedBehavior["AnimationFrame"] = 1] = "AnimationFrame";
})(UnsupportedBehavior || (UnsupportedBehavior = {}));



;// CONCATENATED MODULE: ./node_modules/@shopify/react-idle/build/esm/hooks.mjs



function useIdleCallback(callback, {
  unsupportedBehavior = UnsupportedBehavior.AnimationFrame
} = {}) {
  const handle = (0,react.useRef)(null);
  (0,react.useEffect)(() => {
    if ('requestIdleCallback' in window) {
      handle.current = window.requestIdleCallback(() => callback());
    } else if (unsupportedBehavior === UnsupportedBehavior.AnimationFrame) {
      handle.current = window.requestAnimationFrame(() => {
        callback();
      });
    } else {
      callback();
    }

    return () => {
      const {
        current: currentHandle
      } = handle;
      handle.current = null;

      if (currentHandle == null) {
        return;
      }

      if ('cancelIdleCallback' in window) {
        window.cancelIdleCallback(currentHandle);
      } else if (unsupportedBehavior === UnsupportedBehavior.AnimationFrame) {
        window.cancelAnimationFrame(currentHandle);
      }
    };
  }, [callback, unsupportedBehavior]);
}




/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(72002); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);